import React from 'react';
import { formatQuadrantLabel } from '../utils/geoPresentation';
import { getQuadrantPillStyle } from '../../../utils/pillStyles';

export default function GeoQuadrantPill({ quadrantKey }) {
  const label = formatQuadrantLabel(quadrantKey);
  return (
    <span className="pill" style={getQuadrantPillStyle(quadrantKey)}>
      {label}
    </span>
  );
}
